import React from "react";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useSytContext } from "../providers/SytProvider";
import "./ContactUsModal.scss";

const DEFAULT_LOGO = require("../../assets/images/logos/trip-logo.png");

const ContactUsModal = ({ open, onClose }) => {
  const { logo } = useSytContext();
  const BASE = process.env.REACT_APP_BASE_URL;
  const logoSrc = logo ? `${BASE}${logo.substring(1)}` : DEFAULT_LOGO;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={560}
      className="contact-us-modal"
      destroyOnClose
    >
      <button
        type="button"
        className="contact-us-modal__close"
        onClick={onClose}
        aria-label="Close"
      >
        <CloseOutlined className="contact-us-modal__close-icon" />
      </button>

      <div className="contact-us-modal__header">
        <img src={logoSrc} alt="Shop Your Trip" className="contact-us-modal__logo" />
        <h2 className="contact-us-modal__title">24x7 Support</h2>
      </div>

      <p className="contact-us-modal__subtitle">
        Need Help? we are here 24x7 for your business and account needs!!
      </p>

      <div className="contact-us-modal__body">
        <div className="contact-us-modal__details">
          <div className="contact-us-modal__row">
            <span className="contact-us-modal__label">Email:</span>
            <div className="contact-us-modal__values">
              <a href="mailto:operations@shopyourtrip.com">
                operations@shopyourtrip.com
              </a>
              <a href="mailto:contact@shopyourtrip.com">contact@shopyourtrip.com</a>
            </div>
          </div>
          <div className="contact-us-modal__row">
            <span className="contact-us-modal__label">Contact No:</span>
            <div className="contact-us-modal__values">
              <a href="tel:+919654544469">+91 9654544469</a>
              <a href="tel:+919999442804">+91 9654544464</a>
            </div>
          </div>
        </div>
      </div>

      <button type="button" className="contact-us-modal__footer-btn" onClick={onClose}>
        Close
      </button>
    </Modal>
  );
};

export default ContactUsModal;
